import './ReplayLink.css';
import { Icon } from '../../components/Icon';
import { t } from '../../copy/strings';
import { useTvOn } from '../../state/hooks';

/**
 * "Reveja apurações" (FB-02, PG-06 a): a entrada do site do replay no grupo de status do cabeçalho. Um `<a>` na mesma
 * aba para `VITE_REPLAY_URL` (o hub de noites); sem a variável, não existe. Fora da TV. No celular e no cabeçalho
 * estreito, só o ícone, com o nome acessível e o alvo de 44 px. Nenhum texto dele cita resultado.
 */
export function ReplayLink() {
  const tv = useTvOn();
  const url = import.meta.env.VITE_REPLAY_URL;
  if (!url || tv) return null;
  return (
    <a class="replay-link" href={url} data-testid="replay-link" aria-label={t('nav.replay.aria')}>
      <Icon name="history" size={14} />
      <span class="replay-link__label">{t('nav.replay')}</span>
    </a>
  );
}
